import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { getPageName } from '../../../../../utils/pageName';
import { RestrictedModalLayout } from '../RestrictedModalLayout';

import { ModalRestrictedContainer } from '../../modal-container/ModalRestrictedContainer';
import { MaterialIcon } from '../../../../material-icon/MaterialIcon';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { BrandHyperlink } from '../../../../button/brand/BrandHyperlink';
import { useLoginModal } from '../../../../../login/useLoginModal';

type Props = {
  closeModal: () => void;
  source: string;
  isOpen: boolean;
};

export const CommentariesRestrictedModal: FC<Props> = ({
  closeModal,
  source,
  isOpen,
}) => {
  const sourcePage: string = getPageName();

  const { openLoginModal } = useLoginModal();

  const openLoginCta = () => {
    closeModal();
    openLoginModal({ source });
  };

  return (
    <ModalRestrictedContainer onRequestClose={closeModal} isOpen={isOpen}>
      <RestrictedModalLayout closeModal={closeModal} source={source}>
        <MaterialIcon name="lock" className="restricted-modal__big-icon" />
        <div className="restricted-modal__title">
          <FormattedMessage id="public/CommentariesRestrictedModal.tsx/1" />
        </div>
        <span className="restricted-modal__subtitle">
          <FormattedMessage
            id="public/CommentariesRestrictedModal.tsx/2"
            values={{ br: <br /> }}
          />
        </span>
        <div className="restricted-modal__start-button">
          <BrandHyperlink
            large
            href={buildUrlWithParameters('/inscription', {
              source,
              sourcePage,
            })}
            iconLeft="arrow_forward"
          >
            <FormattedMessage id="public/CommentariesRestrictedModal.tsx/3" />
          </BrandHyperlink>
        </div>
        <div className="restricted-modal__bottom">
          <FormattedMessage id="public/CommentariesRestrictedModal.tsx/4" />
          <button
            type="button"
            className="restricted-modal__bottom__link"
            onClick={openLoginCta}
          >
            <FormattedMessage id="public/CommentariesRestrictedModal.tsx/5" />
          </button>
        </div>
      </RestrictedModalLayout>
    </ModalRestrictedContainer>
  );
};
